// i18n engine + strings shared by every page. Page modules register their own strings with App.i18n.add.
// UI languages: ko, zh-CN (simplified Chinese). Game data names come from the catalogs (KR / TW).
'use strict';
(function () {
  const App = window.App = window.App || {};
  const LANGS = ['ko', 'zh-CN'];
  const dicts = { ko: {}, 'zh-CN': {} };

  App.LANGS = [['ko', '한국어'], ['zh-CN', '简体中文']];
  App.lang = function () {
    const saved = localStorage.getItem('lang');
    if (LANGS.includes(saved)) return saved;
    return (navigator.language || '').toLowerCase().startsWith('zh') ? 'zh-CN' : 'ko';
  };
  App.setLang = function (lang) {
    if (!LANGS.includes(lang)) return;
    localStorage.setItem('lang', lang);
    location.reload();
  };
  App.i18n = {
    add(table) {
      for (const lang of Object.keys(table)) Object.assign(dicts[lang] || (dicts[lang] = {}), table[lang]);
    },
    has(key) { return dicts.ko[key] != null; }
  };
  // t('key', a, b) replaces {0}, {1}; a missing key falls back to Korean, then to the key itself.
  App.t = function (key, ...args) {
    const dict = dicts[App.lang()] || dicts.ko;
    let text = dict[key] != null ? dict[key] : (dicts.ko[key] != null ? dicts.ko[key] : key);
    args.forEach((value, index) => { text = text.split('{' + index + '}').join(value == null ? '' : String(value)); });
    return text;
  };

  App.i18n.add({
    ko: {
      brand: 'LbotFramework', brand_sub: '멀티계정 관제',
      nav_dashboard: '대시보드', nav_machines: '머신', nav_licenses: '내 라이선스', nav_templates: '사냥 프로필',
      nav_logs: '로그', nav_admin: '관리자', nav_admin_users: '사용자', nav_admin_licenses: '라이선스 발급·관리',
      nav_admin_machines: '전체 머신', nav_admin_npc: 'NPC 역할', nav_ide: 'QA Studio', nav_menu: '메뉴', nav_admin_characters: '전체 캐릭터', nav_admin_world: '월드 이동',
      login: '로그인', username: '아이디', password: '비밀번호', login_btn: '로그인', logout: '로그아웃',
      login_sub: '계정으로 로그인하세요', e_invalid: '아이디 또는 비밀번호가 올바르지 않습니다.',
      language: '언어',
      conn_connecting: '연결 중', conn_live: '실시간', conn_reconnecting: '재연결 중',
      save: '저장', saved: '저장했습니다', cancel: '취소', close: '닫기', delete: '삭제', edit: '편집', add: '추가',
      confirm: '확인', back: '뒤로', refresh: '새로고침', search: '검색', loading: '불러오는 중…', retry: '다시 시도',
      copy: '복사', copied: '복사했습니다', none: '없음', optional: '선택', required: '필수', apply: '적용',
      discard: '변경 버리기', keep_editing: '계속 편집', unsaved_title: '저장하지 않은 변경사항',
      unsaved_message: '저장하지 않은 변경사항이 있습니다. 버리고 나갈까요?', more: '더 보기', all: '전체',
      empty: '항목이 없습니다.', just_now: '방금 전', secs_ago: '{0}초 전', mins_ago: '{0}분 전',
      hours_ago: '{0}시간 전', days_ago: '{0}일 전', days_n: '{0}일',
      view_as: '{0} 님의 화면을 보는 중', view_as_exit: '내 화면으로',
      role_admin: '관리자', role_user: '사용자',
      e_fail: '요청을 처리하지 못했습니다.', e_network: '서버에 연결할 수 없습니다.',
      e_unauthorized: '로그인이 필요합니다.', e_forbidden: '권한이 없습니다.', e_not_found: '대상을 찾을 수 없습니다.',
      e_bad_json: '요청 형식이 올바르지 않습니다.', e_capability_unavailable: '서버 기능을 지금 사용할 수 없습니다.',
      e_server: '서버 오류가 발생했습니다.',
      lic_unregistered: '미등록', lic_unused: '미사용', lic_waiting: '대기 (첫 실행 시 시작)', lic_active: '사용 중',
      lic_expired: '만료', lic_revoked: '회수됨', lic_days_left: '{0}일 남음', lic_none: '라이선스 없음',
      short_blocking: '보급 부족 · 출발 대기', short_partial: '보급 부족 · 가능한 만큼 사고 사냥 계속',
      short_adena: '필요 {0} 아데나 / 보유 {1}', short_purchase_failed: '구매 실패',
      page_not_found: '페이지를 찾을 수 없습니다.',
      pick_ph_item: '아이템 검색', pick_ph_itemName: '아이템 이름 검색', pick_ph_map: '맵 검색', pick_ph_monster: '몬스터 검색',
      pick_ph_region: '구역 검색 (맵 먼저)', pick_ph_regionName: '구역 검색 (맵 먼저)', pick_ph_skill: '스킬 검색',
      pick_ph_buff: '버프 검색', pick_ph_npc: 'NPC 검색',
      pick_add_item: '추가할 아이템 검색…', pick_add_itemName: '추가할 아이템 검색…', pick_add_map: '추가할 맵 검색…',
      pick_add_monster: '추가할 몬스터 검색…', pick_add_region: '추가할 구역 검색…', pick_add_regionName: '추가할 구역 검색…',
      pick_add_skill: '추가할 스킬 검색…', pick_add_buff: '추가할 버프 검색…', pick_add_npc: '추가할 NPC 검색…',
      pick_use_text: '“{0}” 그대로 사용', pick_no_match: '일치하는 항목이 없습니다',
      sel_count: '{0}개 선택됨', sel_clear: '선택 해제', sel_all: '전체 선택', sel_row: '선택',
      sel_hint: 'Shift·Ctrl 클릭으로 여러 개를 선택할 수 있습니다.'
    },
    'zh-CN': {
      brand: 'LbotFramework', brand_sub: '多账号管控',
      nav_dashboard: '仪表盘', nav_machines: '机器', nav_licenses: '我的授权', nav_templates: '狩猎方案',
      nav_logs: '日志', nav_admin: '管理员', nav_admin_users: '用户', nav_admin_licenses: '授权发放与管理',
      nav_admin_machines: '全部机器', nav_admin_npc: 'NPC 角色', nav_ide: 'QA Studio', nav_menu: '菜单', nav_admin_characters: '全部角色', nav_admin_world: '世界移动',
      login: '登录', username: '账号', password: '密码', login_btn: '登录', logout: '退出登录',
      login_sub: '请使用账号登录', e_invalid: '账号或密码不正确。',
      language: '语言',
      conn_connecting: '连接中', conn_live: '实时', conn_reconnecting: '重新连接中',
      save: '保存', saved: '已保存', cancel: '取消', close: '关闭', delete: '删除', edit: '编辑', add: '添加',
      confirm: '确认', back: '返回', refresh: '刷新', search: '搜索', loading: '加载中…', retry: '重试',
      copy: '复制', copied: '已复制', none: '无', optional: '可选', required: '必填', apply: '应用',
      discard: '放弃更改', keep_editing: '继续编辑', unsaved_title: '未保存的更改',
      unsaved_message: '有未保存的更改。确定放弃并离开吗？', more: '更多', all: '全部',
      empty: '没有项目。', just_now: '刚刚', secs_ago: '{0} 秒前', mins_ago: '{0} 分钟前',
      hours_ago: '{0} 小时前', days_ago: '{0} 天前', days_n: '{0} 天',
      view_as: '正在查看 {0} 的界面', view_as_exit: '返回我的界面',
      role_admin: '管理员', role_user: '用户',
      e_fail: '请求处理失败。', e_network: '无法连接服务器。',
      e_unauthorized: '需要登录。', e_forbidden: '没有权限。', e_not_found: '找不到对象。',
      e_bad_json: '请求格式不正确。', e_capability_unavailable: '服务器功能暂时不可用。',
      e_server: '服务器发生错误。',
      lic_unregistered: '未登记', lic_unused: '未使用', lic_waiting: '待启用（首次运行时开始）', lic_active: '使用中',
      lic_expired: '已过期', lic_revoked: '已收回', lic_days_left: '剩余 {0} 天', lic_none: '无授权',
      short_blocking: '补给不足 · 等待出发', short_partial: '补给不足 · 已买可买的部分并继续狩猎',
      short_adena: '需要 {0} 金币 / 持有 {1}', short_purchase_failed: '购买失败',
      page_not_found: '找不到页面。',
      pick_ph_item: '搜索物品', pick_ph_itemName: '搜索物品名称', pick_ph_map: '搜索地图', pick_ph_monster: '搜索怪物',
      pick_ph_region: '搜索区域（先选地图）', pick_ph_regionName: '搜索区域（先选地图）', pick_ph_skill: '搜索技能',
      pick_ph_buff: '搜索增益', pick_ph_npc: '搜索 NPC',
      pick_add_item: '搜索要添加的物品…', pick_add_itemName: '搜索要添加的物品…', pick_add_map: '搜索要添加的地图…',
      pick_add_monster: '搜索要添加的怪物…', pick_add_region: '搜索要添加的区域…', pick_add_regionName: '搜索要添加的区域…',
      pick_add_skill: '搜索要添加的技能…', pick_add_buff: '搜索要添加的增益…', pick_add_npc: '搜索要添加的 NPC…',
      pick_use_text: '直接使用“{0}”', pick_no_match: '没有匹配项',
      sel_count: '已选择 {0} 项', sel_clear: '取消选择', sel_all: '全选', sel_row: '选择',
      sel_hint: '可按住 Shift 或 Ctrl 点击多选。'
    }
  });
})();
